export const Type = {
  UPLOAD_FILE_SET: "uploadFileSet",
  UPLOAD_FILE_RESET: "uploadFileReset",
  UPLOAD_FILE_ASYNC: "uploadFileAsync",
};
